import { startCase } from 'lodash-es';

/**
 * @returns the current page ID; for pages which are dashboards, also appends "Dashboard".
 * @example https://jabimaur-a.qa.unanet.io/jabimaur-a/action/organizations => "Organizations Dashboard"
 * @example https://jabimaur-a.qa.unanet.io/jabimaur-a/action/organizations/list => "Organizations List"
 * @example https://jabimaur-a.qa.unanet.io/jabimaur-a/spa_action/fixed_assets => "Fixed Assets Dashboard"
 */
export const getCurrentPageId = () => {
  const path = window.location.pathname;
  const keep = path.substring(path.indexOf('action/') + 'action/'.length);
  let page = startCase(keep.split(/[/_-]/).join(' '));

  if (document.title.toLowerCase().includes('dashboard')) {
    page += ' Dashboard';
  }
  return page;
};

/**
 * @returns whether or not the current page is a React (unanet-react) page or legacy web app page.
 */
export const isReactPage = () => {
  const path = window.location.pathname;
  return path.includes('/spa_action/');
};
